import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DashboardKpiService, SalesSummaryEntity, SalesSummaryGroup } from 'gung-dashboard';
import { format } from 'date-fns';
import { Observable, forkJoin } from 'rxjs';
import { first, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ColmecDashboardKpiService extends DashboardKpiService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  public getSalesSummary(
    entity: SalesSummaryEntity,
    fromDate: Date,
    toDate: Date = null
  ): Observable<SalesSummaryGroup[]> {
    // In case there is a final date defined
    // then retrieve the data for both dates as starting dates
    // then subtract the values for after the toDate
    if (!!toDate) {
      return forkJoin({
        olderSalesSummaryGroups: this.getSalesSummary(entity, fromDate).pipe(first()),
        recentSalesSummaryGroups: this.getSalesSummary(entity, toDate).pipe(first())
      }).pipe(
        first(),
        map(({ olderSalesSummaryGroups, recentSalesSummaryGroups }) => {
          // go through all olderSalesSummaryGroup and subsctrat the quantities from recentSalesSummaryGroups
          // In Case the totalQty are equal in both older and recent
          // that means that the invoice were made on-or-after the toDate (only in the period of the recent one)
          // those should not be added to the return array
          const toReturn: SalesSummaryGroup[] = [];
          const olderSalesSummaryGroupsCopy: SalesSummaryGroup[] = JSON.parse(JSON.stringify(olderSalesSummaryGroups));

          for (const olderSalesSummaryGroup of olderSalesSummaryGroupsCopy) {
            const recentSalesSummaryGroup = recentSalesSummaryGroups.find(
              summary => summary.id === olderSalesSummaryGroup.id
            );

            // in case product bought on-or-after toDate check
            //      THEN if the totalQty is different and add if diff
            // otherwise in not found in recent it means it was bought only in period fromDate until toDate
            if (!!recentSalesSummaryGroup) {
              if (recentSalesSummaryGroup.totalQuantity !== olderSalesSummaryGroup.totalQuantity) {
                olderSalesSummaryGroup.totalAmount -= recentSalesSummaryGroup.totalAmount;
                olderSalesSummaryGroup.totalQuantity -= recentSalesSummaryGroup.totalQuantity;
                toReturn.push(olderSalesSummaryGroup);
              }
            } else {
              toReturn.push(olderSalesSummaryGroup);
            }
          }

          return toReturn;
        })
      );
    }

    const url = 'json/dashboard/sales-summary';
    return this.http.get<SalesSummaryGroup[]>(url, {
      params: {
        fromDate: format(fromDate, 'yyyy-MM-dd'),
        entity: SalesSummaryEntity[entity]
      }
    });
  }
}
